import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import IconLeft from 'components/icons/left';
import IconRight from 'components/icons/right';

import { setActiveSpread } from 'redux/reducers/app';
import { trackEvent } from 'redux/reducers/user';

import { getCurrentBookSpreads } from 'redux/selectors/books';
import { getActiveSpreadId } from 'redux/selectors/app';
import { calculateProgress } from 'redux/selectors/stats';

import { PaginationPage } from 'components';

import cx from 'classnames';
import styles from './styles.scss';

const iconLeft = (
  <div className={styles.navIcon}>
    <IconLeft />
  </div>
);
const iconRight = (
  <div className={styles.navIcon}>
    <IconRight />
  </div>
);
const KEY_RIGHT = 39;
const KEY_LEFT = 37;

@connect(
  state => ({
    spreads: getCurrentBookSpreads(state),
    currentSpread: getActiveSpreadId(state),
    progress: calculateProgress(state),
  }),
  {
    setActiveSpread,
    track: trackEvent,
  }
)
export default class Pagination extends React.PureComponent {
  static contextTypes = {
    orderId: PropTypes.string,
  };

  setActiveSpread = e => {
    e.preventDefault();
    const id = e.currentTarget.dataset.id;

    if (id) {
      this.props.setActiveSpread(id);
    }
  };

  constructor(p) {
    super(p);
    this._keyBindings = this._keyBindings.bind(this);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this._keyBindings);
  }

  componentDidMount() {
    document.addEventListener('keydown', this._keyBindings);
  }

  _keyBindings(e) {
    // TODO: #185
    switch (e.keyCode) {
      case KEY_RIGHT: {
        break;
      }
      case KEY_LEFT: {
        break;
      }
      default:
        break;
    }
  }

  render() {
    const { currentSpread, spreads, progress, arrowsOnly, track } = this.props;
    const { orderId } = this.context;

    if (!spreads || spreads.count() === 1) {
      return <div />;
    }

    const currentSpreadIndex = spreads.findIndex(spread => spread.get('id') === currentSpread);
    const previousSpread = currentSpreadIndex > 0 ? spreads.get(currentSpreadIndex - 1, null) : null;
    const nextSpread = currentSpreadIndex + 1 < spreads.count() ? spreads.get(currentSpreadIndex + 1, null) : null;

    const previousClasses = cx(styles.nav, styles.left, {
      [styles.disabled]: !previousSpread,
    });
    const nextClasses = cx(styles.nav, styles.right, {
      [styles.disabled]: !nextSpread,
    });

    return arrowsOnly ? (
      <div>
        <PaginationPage
          className={previousClasses + ' ' + styles.pageMargin}
          spread={previousSpread}
          hideLabel={true}
          track={track}
          setActiveSpread={this.setActiveSpread}>
          {iconLeft}
        </PaginationPage>
        <PaginationPage
          className={nextClasses + ' ' + styles.pageMargin}
          spread={nextSpread}
          hideLabel={true}
          track={track}
          setActiveSpread={this.setActiveSpread}>
          {iconRight}
        </PaginationPage>
      </div>
    ) : (
      <div className={styles.pagination}>
        <PaginationPage
          className={previousClasses}
          spread={previousSpread}
          track={track}
          setActiveSpread={this.setActiveSpread}>
          {iconLeft}
        </PaginationPage>
        <div className={styles.spreads}>
          {spreads
            .map(spread => (
              <PaginationPage
                key={`${orderId}-${spread.get('id')}-${spread.get('monthIndex', '')}-${spread.get(
                  'monthSpreadIndex',
                  ''
                )}`}
                track={track}
                spread={spread}
                partial={progress.getIn([spread.get('id'), 'partial'])}
                seen={progress.getIn([spread.get('id'), 'seen'])}
                done={progress.getIn([spread.get('id'), 'done'])}
                active={spread.get('id') === currentSpread}
                setActiveSpread={this.setActiveSpread}
              />
            ))
            .toArray()}
        </div>
        <PaginationPage
          className={nextClasses}
          spread={nextSpread}
          track={track}
          setActiveSpread={this.setActiveSpread}>
          {iconRight}
        </PaginationPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/pagination/index.js